export default __webpack_public_path__ + "assets/zisla-logo-white.d9292978.png";